<template>
  <div class="md-layout">
    <div class="md-layout-item" id="filter-box">
      <md-field>
        <md-icon class="text-primary">star_rate</md-icon>
        <label>Minimum Potential</label>
        <md-input v-model="potential" type="number" min="1" max="5"></md-input>
      </md-field>

      <md-field>
        <label for="type">Type</label>
        <md-select v-model="type" name="type" id="type" multiple>
          <md-option
            v-for="adventureType in types"
            :key="adventureType.value"
            :value="adventureType.value"
          >
            {{ adventureType.key }}
          </md-option>
        </md-select>
      </md-field>

      <md-field>
        <label for="tour">Adventure</label>
        <md-select v-model="tour" name="tour" id="tour" multiple>
          <md-option v-for="tour in tours" :key="tour.id" :value="tour.id">
            {{ tour.title }}
          </md-option>
        </md-select>
      </md-field>

      <md-field>
        <label for="manager">Manager</label>
        <md-select v-model="manager" name="manager" id="manager">
          <md-option
            v-for="manager in managers"
            :key="manager.id"
            :value="manager.id"
          >
            {{ manager.full_name }}
          </md-option>
        </md-select>
      </md-field>

      <div class="date-range">
        <md-datepicker
          v-model="followup"
          md-immediately
          :md-model-type="String"
        >
          <label>Follow Up</label>
        </md-datepicker>
      </div>

      <md-switch v-model="completed">Include Completed</md-switch>

      <md-button
        class="md-raised md-dense md-success mt-4"
        @click.prevent="applyFilter"
        >Filter</md-button
      >

      <md-button
        class="md-icon-button md-dense md-danger md-round mt-4"
        id="clearFilter"
        @click="clearFilter"
      >
        <md-icon>clear</md-icon>
        <md-tooltip md-direction="top">Clear the Filters</md-tooltip>
      </md-button>
    </div>
  </div>
</template>

<script>
import tourApi from "@/services/api/tour";
import optionsApi from "@/services/api/options";
import { mapFields } from "vuex-map-fields";

export default {
  data() {
    return {
      tours: [],
      managers: [],
      types: [
        { value: "tour", key: "Tour" },
        { value: "event", key: "Event" }
      ]
    };
  },

  computed: {
    ...mapFields("enquiryFilter", [
      "potential",
      "manager",
      "tour",
      "type",
      "completed",
      "followup"
    ])
  },

  methods: {
    applyFilter() {
      this.$emit("filterEnquiries");
    },
    clearFilter() {
      this.$store.dispatch("enquiryFilter/clearFilter");
      this.applyFilter();
    }
  },

  mounted() {
    tourApi.getTours().then(resp => {
      this.tours = resp.data.tours;
    });

    optionsApi.managers().then(resp => {
      this.managers = [{ id: 0, full_name: "All" }].concat(resp.data);
    });
  }
};
</script>
<style lang="scss" scoped>
#filter-box {
  padding: 10px;
  border-radius: 10px;
  min-height: 300px;
  background-color: #e8f8fa;
}

#clearFilter {
  float: right;
}
</style>
